import data from './proposalSeed2026.json';
export default data;
